/**
 * Plan de flota: 141 equipos; el N° de máquina en campo empieza en 1001 (1001…1141).
 * Los ids de fila en `machines.id` deberían alinearse con ese mismo número operativo.
 */
export const FLEET_TARGET_MACHINES = 141;
export const FLEET_FIRST_MACHINE_NO = 1001;
export const FLEET_LAST_MACHINE_NO =
  FLEET_FIRST_MACHINE_NO + FLEET_TARGET_MACHINES - 1;

export const FLEET_TARGET_TX_PER_MACHINE_DAY = 100;
